/* src/app/dashboard/team-results/team-results.component.css */
.team_container {
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  margin-top: 6vh;
  width: 100%;
}
.team_panel_holder {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}
.team_top {
  color: var(--primary-color);
  font-size: 4.0vw;
  font-weight: bold;
}
.team_bottom {
  color: var(--secondary-color);
  font-size: 2vw;
  font-weight: normal;
}
:host-context(.dark-mode) .team_top {
  color: var(--green-accent) !important;
}
:host-context(.dark-mode) .team_bottom {
  color: var(--dark-text-color) !important;
}
.team_center {
  border-left-color: #E0E1E2;
  border-left-style: solid;
  border-left-width: 1px;
  border-right-color: #E0E1E2;
  border-right-style: solid;
  border-right-width: 1px;
}
@media (max-width: 600px) {
  .team_top {
    font-size: 10.0vw;
  }
  .team_bottom {
    font-size: 4vw;
  }
}
/*# sourceMappingURL=team-results.component.css.map */
